/** The `crown_health` kind's options (backend `viewer/report_kinds.py`, CROWN_HEALTH_OPTIONS) as the page reads them. */

export type CrownHealthSection = 'map' | 'summary' | 'genera';
export const CROWN_HEALTH_SECTIONS: CrownHealthSection[] = ['map', 'summary', 'genera'];
/** What the crowns are coloured by when the page opens: their category or their stress z-score. */
export type CrownHealthColorBy = 'health' | 'stress';

export interface CrownHealthConfig {
  sections: Record<CrownHealthSection, { enabled: boolean }>;
  colorBy: CrownHealthColorBy;
}

const isObject = (v: unknown): v is Record<string, unknown> => v !== null && typeof v === 'object' && !Array.isArray(v);

/** The stored options over the defaults: a report saved before an option existed still has it. */
export function crownHealthConfig(raw: unknown): CrownHealthConfig {
  const stored = isObject(raw) ? raw : {};
  const sections = isObject(stored.sections) ? stored.sections : {};
  return {
    sections: Object.fromEntries(
      CROWN_HEALTH_SECTIONS.map((s) => {
        const v = sections[s];
        return [s, { enabled: isObject(v) && typeof v.enabled === 'boolean' ? v.enabled : true }];
      }),
    ) as CrownHealthConfig['sections'],
    colorBy: stored.color_by === 'stress' ? 'stress' : 'health',
  };
}
